import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getUserInfo, { GetUserInfoInput, GetUserInfoOutput } from '.';

type TrimmedGetUserInfoInput = Omit<GetUserInfoInput, 'dlVaultContract'>;

export type UseGetUserInfoQueryKey = [
  FunctionKey.GET_USER_INFO,
  TrimmedGetUserInfoInput,
];

type Options = QueryObserverOptions<
  GetUserInfoOutput,
  Error,
  GetUserInfoOutput,
  GetUserInfoOutput,
  UseGetUserInfoQueryKey
>;

const useGetUserInfo = (input: TrimmedGetUserInfoInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_USER_INFO, input],
    () => getUserInfo({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetUserInfo; 